/**
 * Created by kz on 28.06.17.
 */
import * as api from '@api/tender'
import * as participationApi from '@api/participation'

export const all = ({commit}) => {
  commit('loading', true, {root: true})
  return api.getTenders()
    .then(({data}) => {
      commit('receive', data)
      commit('loading', false, {root: true})
    })
}

export const get = ({commit}, id) => {
  commit('loading', null, {root: true})
  return api.getTender(id)
    .then(({data}) => {
      data.createdAt = new Date(data.createdAt)
      data.stages.map((s) => {
        if (s.scheduledLaunch) {
          s.scheduledLaunch = new Date(s.scheduledLaunch)
        }
        if (s.scheduledSuspend) {
          s.scheduledSuspend = new Date(s.scheduledSuspend)
        }
        return s
      })
      commit('current', data)
      commit('loading', false, {root: true})
    })
    .catch(() => {
      commit('errorMessage', 'Ошибка загрузки тендера', {root: true})
      commit('loading', false, {root: true})
    })
}

export const create = ({dispatch, commit}, {name, description, holderName}) => {
  commit('loading', true, {root: true})
  return api.createTender({name, description, holderName})
    .then(() => {
      return dispatch('all')
    })
    .then(() => {
      commit('successMessage', 'Тендер создан', {root: true})
      commit('loading', false, {root: true})
      return true
    })
}

export const describe = ({dispatch, commit, state}, {name, description, holderName}) => {
  commit('loading', true, {root: true})
  return api.describe(state.current._id, {name, description, holderName})
    .then(() => {
      return dispatch('get', state.current._id)
    })
    .then(() => {
      commit('successMessage', 'Тендер обновлен', {root: true})
      commit('loading', false, {root: true})
      return true
    })
}

export const archive = ({dispatch, commit}, id) => {
  commit('loading', true, {root: true})
  return api.archive(id)
    .then(() => {
      return dispatch('all')
    })
    .then(() => {
      commit('successMessage', 'Тендер отправлен в архив', {root: true})
      commit('loading', false, {root: true})
      return true
    })
}

export const attachConditions = ({dispatch, commit, state}, condtitions) => {
  commit('loading', true, {root: true})
  return api.conditions(state.current._id, condtitions)
    .then(() => {
      return dispatch('all')
    })
    .then(() => {
      commit('successMessage', 'Условия загружены', {root: true})
      commit('loading', false, {root: true})
      return true
    })
}

export const addStage = ({dispatch, commit, state}, stage) => {
  commit('loading', true, {root: true})
  return api.addStage(state.current._id, stage)
    .then(() => {
      return dispatch('get', state.current._id)
    })
    .then(() => {
      commit('successMessage', 'Этап добавлен', {root: true})
      commit('loading', false, {root: true})
      return true
    })
}

export const renameStage = ({dispatch, commit, state}, {id: stageId, name}) => {
  commit('loading', true, {root: true})
  return api.renameStage(state.current._id, stageId, name)
    .then(() => {
      return dispatch('get', state.current._id)
    })
    .then(() => {
      commit('successMessage', 'Этап переименован', {root: true})
      commit('loading', false, {root: true})
      return true
    })
}

export const removeStage = ({dispatch, commit, state}, stageId) => {
  commit('loading', true, {root: true})
  return api.removeStage(state.current._id, stageId)
    .then(() => {
      return dispatch('get', state.current._id)
    })
    .then(() => {
      commit('successMessage', 'Этап удален', {root: true})
      commit('loading', false, {root: true})
      return true
    })
}

export const launchStage = ({dispatch, commit, state}, stageId) => {
  commit('loading', true, {root: true})
  return api.launchStage(state.current._id, stageId)
    .then(() => {
      return dispatch('get', state.current._id)
    })
    .then(() => {
      commit('successMessage', 'Этап запущен', {root: true})
      commit('loading', false, {root: true})
      return true
    })
}

export const suspendStage = ({dispatch, commit, state}, stageId) => {
  commit('loading', true, {root: true})
  return api.suspendStage(state.current._id, stageId)
    .then(() => {
      return dispatch('get', state.current._id)
    })
    .then(() => {
      commit('successMessage', 'Этап остановлен', {root: true})
      commit('loading', false, {root: true})
      return true
    })
}

export const inviteToStage = ({dispatch, commit, state}, {stageId, invites}) => {
  commit('loading', true, {root: true})
  return api.inviteToStage(state.current._id, stageId, invites)
    .then(() => {
      return dispatch('getTenderStageParticipations', stageId)
    })
    .then(() => {
      commit('successMessage', 'Участники приглашены', {root: true})
      commit('loading', false, {root: true})
      return true
    })
}

export const loadLotsToStage = ({dispatch, commit, state}, {stageId, lots, keys}) => {
  commit('loading', true, {root: true})
  return api.loadLotsToStage(state.current._id, stageId, {lots, keys})
    .then(() => {
      return dispatch('get', state.current._id)
    })
    .then(() => {
      commit('successMessage', 'Лоты загружены', {root: true})
      commit('loading', false, {root: true})
      return true
    })
}

export const stageQuestionnaire = ({dispatch, commit, state}, {stageId, questionnaire}) => {
  commit('loading', true, {root: true})
  return api.stageQuestionnaire(state.current._id, stageId, questionnaire)
    .then(() => {
      return dispatch('get', state.current._id)
    })
    .then(() => {
      commit('successMessage', 'Анкета сохранена', {root: true})
      commit('loading', false, {root: true})
      return true
    })
}

export const getTenderStageParticipations = ({commit, state, rootState}, stageId) => {
  commit('loading', true, {root: true})
  return api.getTenderStageParticipations(rootState.route.params.id || state.current._id, stageId || rootState.route.params.stageId)
    .then(({data}) => {
      commit('stageParticipations', data)
      return true
    })
    .then(() => {
      commit('loading', false, {root: true})
      return true
    })
}

export const planStageDates = ({commit, state, dispatch}, {stageId, scheduledLaunch, scheduledSuspend}) => {
  return api.planStageDates(state.current._id, stageId, {scheduledLaunch, scheduledSuspend})
    .then(() => {
      return dispatch('get', state.current._id)
    }).then(() => {
      commit('successMessage', 'Даты запланированы', {root: true})
    })
}

export const report = ({commit, state, dispatch}, stageId) => {
  return api.report(state.current._id, stageId)
    .then(() => {
      commit('successMessage', 'Расчет произведен', {root: true})
    })
}

export const disableParticipation = ({commit, dispatch, state}, participationId) => {
  commit('loading', true, {root: true})
  return participationApi.disable(participationId).then(() => {
    return dispatch('getTenderStageParticipations')
  }).catch(() => {
    commit('errorMessage', 'Ошибка выключения', {root: true})
    commit('loading', false, {root: true})
  })
}

export const enableParticipation = ({commit, dispatch, state}, participationId) => {
  commit('loading', true, {root: true})
  return participationApi.enable(participationId).then(() => {
    return dispatch('getTenderStageParticipations')
  }).catch(() => {
    commit('errorMessage', 'Ошибка включения', {root: true})
    commit('loading', false, {root: true})
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/tender/actions.js